import messages from 'aurora-translations';

const errorMapper = errorObject => {
  const { response: { data } = {}, message: errMessage } = errorObject;
  // const isJsonBlob = data1 => data1 instanceof Blob && data1.type === 'application/json';

  // const errorResult = isJsonBlob(data) ? await errorObject.response?.data?.text() : '';
  // console.log('errorDocument', errorResult);
  const message = data?.result?.description || data?.error || data?.message || data?.description || errMessage;
  console.log(message);
  const statusCode = data?.code || data?.statusCode || data?.result?.statusCode || errorObject.code;
  const localizeKey = `error_${statusCode}`;
  const error = {
    data,
    // message: messages[localizeKey]?.id ? localizeKey : message || 'oops_something_went_wrong',
    message: messages[localizeKey]?.id ? localizeKey : 'oops_something_went_wrong',
    statusCode,
  };

  return error;
};

export default errorMapper;
